/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import * as CRISPRConstants from 'constants/CRISPRConstants';
import CRISPRDefaults, {CRISPRUserSettings} from 'molbio/crispr/CRISPRDefaults';
import GenomeSelector from 'molbio/genome/GenomeSelector';
import GenomeStore from 'stores/GenomeStore';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';

interface Props {
  initialGenome?: any;
}

type State = any;

class CRISPRIASettingsForm extends React.Component<Props, State> {
  state: State = {
    crisprIaType: CRISPRConstants.IA_TYPE.CRISPR_A,
    genome: this.props.initialGenome.ensemblName,
    name: 'Untitled',
  };

  getAllSettings = (): ReturnType<typeof this.getAnalysisSettings> => this.getAnalysisSettings();

  getAnalysisSettings = (): CRISPRUserSettings & {
    crisprIaType: string;
    designType: CRISPRConstants.DESIGN_TYPE;
    genome: any;
    isLeftPam: boolean;
    name: string;
  } => {
    const settings = CRISPRDefaults.getDefaults();
    return Object.assign(settings, {
      name: this.state.name,
      crisprIaType: this.state.crisprIaType,
      designType: CRISPRConstants.DESIGN_TYPE.SINGLE,
      genome: this.state.genome,
      isLeftPam: false,
    });
  };

  updateCrisprIaType = (e: any): void => {
    this.setState({crisprIaType: e.target.value});
  };

  render(): JSX.Element {
    return (
      <div>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Design type</Label>
            </Col>
            <Col sm={8}>
              <div className="radio">
                <label>
                  <input
                    type="radio"
                    value={CRISPRConstants.IA_TYPE.CRISPR_A}
                    checked={this.state.crisprIaType === CRISPRConstants.IA_TYPE.CRISPR_A}
                    onChange={this.updateCrisprIaType}
                  />
                  CRISPRa
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    type="radio"
                    value={CRISPRConstants.IA_TYPE.CRISPR_I}
                    checked={this.state.crisprIaType === CRISPRConstants.IA_TYPE.CRISPR_I}
                    onChange={this.updateCrisprIaType}
                  />
                  CRISPRi
                </label>
              </div>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Genome</Label>
            </Col>
            <Col sm={8}>
              <GenomeSelector
                genomes={GenomeStore.getGenomes()}
                genomeLink={{
                  value: this.state.genome,
                  requestChange: (genome) => {
                    this.setState({genome});
                  },
                }}
              />
            </Col>
          </Row>
        </FormGroup>
      </div>
    );
  }
}

export default CRISPRIASettingsForm;
